import { Card, Col, Container, Row } from "react-bootstrap"
import { Helmet } from "react-helmet";

const RewardsPage = () => {
    return (<>
        <Helmet>
            <title>Darknet Games | Rewards</title>
        </Helmet>
        <Container>
            <Row>
                <Col>
                    <Card className="card-widget" id="rewards-widget">
                        <Card.Header>
                            <Card.Title className="text-light text-center fs-3 fs-3">
                                Rewards
                            </Card.Title>
                        </Card.Header>
                        <Card.Body>
                            Coming soon!
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>
    );
}

export default RewardsPage;